import { Typography } from "@app/components/atoms";

export default function AdminDashboard() {
  return (
    <div className="">
      <Typography tag="h1">Welcome to admin panel!</Typography>
    </div>
  );
}
